/** Where an arrow, Home or End key moves the focus in a group of `count` cards, wrapping at the ends; null for other keys. */
export const getTargetIndex = (key: string, current: number, count: number): number | null => {
  switch (key) {
    case 'ArrowRight':
    case 'ArrowDown':
      return (current + 1) % count;
    case 'ArrowLeft':
    case 'ArrowUp':
      return (current - 1 + count) % count;
    case 'Home':
      return 0;
    case 'End':
      return count - 1;
    default:
      return null;
  }
};
